import Vue from 'vue';
import Vuex from 'vuex';
import { getStorage, setStorage } from '../assets/js/util2';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    catchArr: ['emptyLayout', 'checkResult', 'signInEveryDay', 'goldExchange'], //保存缓存的列表(checkResult是固定要缓存的组件）
    payData: getStorage('payData', 'arr'),
    currentPay: getStorage('currentPay') || 'IDR'
  },
  getters: {
    currentUnit(state) {
      let currentData = state.payData.filter(item => item.value == state.currentPay)
      return currentData.length ? currentData[0].unit : state.payData[0].unit
    }
  },
  mutations: {
    // 对指定组件进行动态更改缓存（缓存）--组件调用该方法时，判断该组件是否存在于该缓存数组，无则添加
    iskeepAlive(state, component) {
      !state.catchArr.includes(component) && state.catchArr.push(component);
    },
    // 对指定组件进行动态更改缓存（不缓存）--组件调用该方法时，从缓存数组中删除对应的组件元素
    noKeepAlive(state, component) {
      let index = state.catchArr.indexOf(component);
      index > -1 && state.catchArr.splice(index, 1);
    },
    updateCurrentPay(state, data) {
      state.currentPay = data
    },
    updataPayData(state, data) {
      const newPayData = state.payData.filter(item => item.value !== data.value)
      state.payData = newPayData
      setStorage('payData', newPayData, 'arr')
    },
    resetCurrentPay(state) {
      const result = state.payData.some(item => item.value == getStorage('currentPay'))
      return result ? getStorage('currentPay') : state.payData[0].value
    },
    resetPayData(state) {
      state.payData = [
        {
          text: 'IDR(Rp)',
          value: 'IDR',
          unit: 'IDR'
        },
        {
          text: 'THB(฿)',
          value: 'THB',
          unit: '฿'
        },
        {
          text: 'CNY(¥)',
          value: 'CNY',
          unit: '¥'
        }
      ]
    }
  },
  actions: {

  }
})
